// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1K2sR4cqmQGIRcJOxCnins{background-color:#f6f6f6}._2OWnow2Lc370dEvFHwksyp{border-bottom:none !important;padding-bottom:0 !important}\n", "",{"version":3,"sources":["webpack://src/client/pages/shoppingcart/pages/thanks/style.module.scss"],"names":[],"mappings":"AAEA,yBACI,wBAAyB,CAC5B,yBAGG,6BAA8B,CAC9B,2BAA4B","sourcesContent":["@import '../../../../base.scss';\n\n.TransitionContainer {\n    background-color: #f6f6f6;\n}\n\n.SendToSubscribe{\n    border-bottom: none !important;\n    padding-bottom: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TransitionContainer": "_1K2sR4cqmQGIRcJOxCnins",
	"SendToSubscribe": "_2OWnow2Lc370dEvFHwksyp"
};
module.exports = ___CSS_LOADER_EXPORT___;
